import React from 'react';
import './ArticleEnhancements.css';

export const TheorySchema = () => null;

export const VFSOfficer = ({ children }) => (
  <aside className="article-callout article-callout--officer">
    <strong className="article-callout__label">VFS interview note</strong>
    <div>{children}</div>
  </aside>
);

export const InterviewCategories = () => (
  <div className="article-category-grid" aria-label="Interview question categories">
    {['Study purpose', 'Financial background', 'Academic history', 'Future plans'].map((category) => (
      <div className="article-category-card" key={category}>{category}</div>
    ))}
  </div>
);

export const FinancialBreakdown = ({ sources = [] }) => (
  <div className="article-breakdown">
    <h3 className="article-breakdown__title">Financial breakdown</h3>
    <div className="article-breakdown__rows">
      {sources.map((source) => (
        <div className="article-breakdown__row" key={source.source}>
          <span>{source.source}</span>
          <strong>{source.amount}</strong>
          <span>{source.percentage}</span>
        </div>
      ))}
    </div>
  </div>
);

export const CommonMistakesChecklist = ({ items = [] }) => (
  <div className="article-mistakes">
    <h3 className="article-mistakes__title">Common mistakes to avoid</h3>
    <ul>
      {items.map((item) => (
        <li key={item.mistake}>
          <strong>{item.mistake}</strong>
          {item.consequence && <span>{item.consequence}</span>}
        </li>
      ))}
    </ul>
  </div>
);
